import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';

import { ItineraryService } from '../../search-result/services/itinerary.service';
import { OperationLogService } from '../../search-result/services/operation-log.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

@Injectable({ providedIn: 'root' })
export class OperationLogGuard implements CanActivate {
  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private operationService: OperationLogService,
    private layoutService: LayoutService
  ) {}

  private loadOperations(pnr: string, gds: string) {
    return this.api.getOperations(pnr).pipe(
      map((response) => {
        this.layoutService.dispatchChangeBreadcrumb(pnr, OptionType.Log);
        this.operationService.dispatchLoadOperationsSuccess(response);
        return !!response;
      }),
      catchError((response) => {
        this.itineraryService.dispatchGenericError(response);
        this.itineraryService.navigateToWithParams('itinerary/info');
        return of(false);
      })
    );
  }

  canActivate(route?: ActivatedRouteSnapshot) {
    return this.loadOperations(route?.queryParams?.pnr, route?.queryParams?.gds);
  }
}
